module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("School of Fish")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("By Amy Lane")]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("Fish Out of Water: Book Six")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jackson Rivers has spent the last eight weeks recovering from heart surgery and working on healing—body and soul. He’s itching to get back to work when Ellery Cramer, the man he’s been living with for almost a year as well as the lawyer he works for, gives him the simplest task—pick up a file on a kid who probably didn’t commit murder, but who refuses to participate in his own defense.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nothing is ever that easy.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("One case connects to another, which connects to the mob, which connects to the local high school—and a bottomless potential for victims and perpetrators, all of whom are on the move. The case has a lot of moving parts, and Jackson and Ellery have to work hard and fast to make sure the machinery of the mob doesn’t mow over everybody they care about. Or rip them apart.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jackson Rivers has been learning how to take care of himself so he can be there for Ellery, but Ellery has been learning to accept that Jackson will never just let an injustice stand. Together, they’re trying to keep innocent teenagers from going to jail while the streets of Sacramento threaten to explode. They’d better hope they’ve learned enough in the last year to keep it together because for this case, school is the most dangerous place to be.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-677943bf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0002.vue
// module id = 60
// module chunks = 0